module.exports = __webpack_public_path__ + "static/nordic_1-855303e8864439dc3571c96aa546b085.jpg";